"use strict";

var _regeneratorRuntime = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var R = __importStar(require("ramda"));

var react_apollo_1 = require("react-apollo");

var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");

var auth_1 = require("@8base-react/auth");

var apollo_client_1 = require("@8base/apollo-client");

var FragmentsSchemaContainer_1 = require("./FragmentsSchemaContainer");

var ApolloContainer = auth_1.withAuth((_a =
/*#__PURE__*/
function (_react_1$default$Comp) {
  _inherits(ApolloContainer, _react_1$default$Comp);

  function ApolloContainer() {
    var _this;

    _classCallCheck(this, ApolloContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApolloContainer).apply(this, arguments));
    _this.createClient = R.memoizeWith(R.identity, function (introspectionQueryResultData) {
      var _this$props = _this.props,
          withAuth = _this$props.withAuth,
          withSubscriptions = _this$props.withSubscriptions,
          autoSignUp = _this$props.autoSignUp,
          authProfileId = _this$props.authProfileId,
          cacheOptions = _this$props.cacheOptions;
      var commonOptions = {
        cache: introspectionQueryResultData ? new apollo_cache_inmemory_1.InMemoryCache(Object.assign(Object.assign({}, cacheOptions), {
          fragmentMatcher: new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({
            introspectionQueryResultData: introspectionQueryResultData
          })
        })) : new apollo_cache_inmemory_1.InMemoryCache(cacheOptions),
        extendLinks: _this.props.extendLinks,
        onRequestError: _this.props.onRequestError,
        onRequestSuccess: _this.props.onRequestSuccess,
        uri: _this.props.uri,
        subscriptionUri: _this.props.subscriptionUri,
        withSubscriptions: withSubscriptions
      };
      var apolloClientOptions = withAuth ? Object.assign(Object.assign({}, commonOptions), {
        authProfileId: authProfileId,
        autoSignUp: autoSignUp,
        getAuthState: _this.getAuthState,
        onAuthError: _this.onAuthError,
        onIdTokenExpired: _this.onIdTokenExpired,
        withAuth: true
      }) : Object.assign(Object.assign({}, commonOptions), {
        withAuth: false
      });
      return new apollo_client_1.ApolloClient(apolloClientOptions);
    });

    _this.onIdTokenExpired = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var authClient, _ref, idToken;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                authClient = this.props.auth.authClient;
                _context.next = 3;
                return authClient.checkSession({});

              case 3:
                _ref = _context.sent;
                idToken = _ref.idToken;
                authClient.setState({
                  token: idToken
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    _this.onAuthError = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var authClient;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                authClient = this.props.auth.authClient;
                _context2.next = 3;
                return this.client.clearStore();

              case 3:
                authClient.batch(function () {
                  authClient.purgeState();
                  authClient.logout();
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    _this.getAuthState = function () {
      var authState = _this.props.auth.authState;
      return authState;
    };

    _this.renderContent = function (_ref2) {
      var loading = _ref2.loading,
          introspectionQueryResultData = _ref2.introspectionQueryResultData;

      if (loading) {
        return null;
      }

      _this.client = _this.createClient(introspectionQueryResultData);
      return react_1.default.createElement(react_apollo_1.ApolloProvider, {
        client: _this.client
      }, _this.props.children);
    };

    return _this;
  }

  _createClass(ApolloContainer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          uri = _this$props2.uri,
          introspectionQueryResultData = _this$props2.introspectionQueryResultData;

      if (introspectionQueryResultData !== undefined) {
        return this.renderContent({
          loading: false,
          introspectionQueryResultData: introspectionQueryResultData
        });
      }

      return react_1.default.createElement(FragmentsSchemaContainer_1.FragmentsSchemaContainer, {
        uri: uri
      }, this.renderContent);
    }
  }]);

  return ApolloContainer;
}(react_1.default.Component), _a.defaultProps = {
  autoSignUp: false,
  withAuth: true,
  withSubscriptions: false,
  cacheOptions: {}
}, _a));
exports.ApolloContainer = ApolloContainer;